import React, { useState, useEffect } from "react";
import { TextField, Box, Snackbar, Alert } from "@mui/material";
import removeAccents from "remove-accents";

const OriginAddressInput = ({ onValidAddress, errorTrigger }) => {
  const [street, setStreet] = useState("");
  const [region, setRegion] = useState("");
  const [postal, setPostal] = useState("");
  const [showError, setShowError] = useState(false);

  const normalize = (str) => removeAccents(str || "").toUpperCase();

  useEffect(() => {
    const allFilled =
      street.trim().length > 0 &&
      region.trim().length > 0 &&
      postal.trim().length > 0;

    if (allFilled) {
      const fullAddress = `${normalize(street)}, ${normalize(region)}, ${normalize(postal)}`;
      onValidAddress?.(fullAddress);
    } else {
      onValidAddress?.(""); // κενό = μη έγκυρο
      if (errorTrigger) {
        setShowError(true); // δείξε snackbar ΜΟΝΟ όταν ζητηθεί
      }
    }
  }, [street, region, postal, onValidAddress, errorTrigger]);


  const handleBlur = () => {};

  return (
    <Box display="flex" gap={2} flexWrap="wrap" mt={2}>
      <TextField
        label="Οδός"
        value={street}
        onChange={(e) => setStreet(e.target.value.toUpperCase())}
        onBlur={handleBlur}
        fullWidth
      />
      <TextField
        label="Πόλη"
        value={region}
        onChange={(e) => setRegion(e.target.value.toUpperCase())}
        onBlur={handleBlur}
        fullWidth
      />
      <TextField
        label="ΤΚ"
        value={postal}
        onChange={(e) => setPostal(e.target.value.toUpperCase())}
        onBlur={handleBlur}
        fullWidth
      />

      <Snackbar
        open={showError}
        autoHideDuration={3000}
        onClose={() => setShowError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setShowError(false)}>
          Συμπλήρωσε όλα τα πεδία διεύθυνσης!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OriginAddressInput;
